import React from 'react';
import { Route } from 'react-router';
import { RailsViewActions } from '../components/discovery/rails_view_store';
import isNode from '@reverbdotcom/commons/src/is-node';

const EndedWatchedProductsRoute = (
  <Route
    key="watched_products/ended"
    path="watched_products/ended"
    getComponent={(_location, cb) => {
      import(
        /* webpackChunkName: 'feed' */
        '../components/discovery/feed/rails_view'
      ).then(m => cb(null, m.default));
    }}
    onChange={(_, nextState) => {
      RailsViewActions.fetchHTML('/watched_products/ended', nextState.location.query);
    }}
    onEnter={(nextState) => {
      if (isNode) { return; }
      RailsViewActions.fetchHTML('/watched_products/ended', nextState.location.query);
    }}
    onLeave={() => {
      RailsViewActions.clearHTML();
    }}
  />
);

export default EndedWatchedProductsRoute;
